import { Group, Progress, Text } from "@mantine/core";
import { PANEL_COLOR, PANEL_SPACE } from "./tokens";

/** The share as a whole percent, clamped to 0–100. */
export function percentOf(share: number): number {
  if (!Number.isFinite(share)) return 0;
  return Math.max(0, Math.min(100, Math.round(share * 100)));
}

/**
 * One usage line (Figma "Metric"): a 15px bar in `brand/7` on a `gray/1` track, the percent
 * in bold, then what it measures.
 */
export function ProgressMeter({ share, label }: { share: number; label: string }) {
  const pct = percentOf(share);
  return (
    <Group gap={PANEL_SPACE.page} wrap="nowrap">
      <Progress
        value={pct}
        size={15}
        radius={3}
        color="blue.7"
        bg={PANEL_COLOR.fill}
        style={{ flex: 1, minWidth: 60 }}
        aria-label={label}
      />
      <Text fw={700} w={44} lh={1.25}>
        {pct}%
      </Text>
      <Text w={180} lh={1.25}>
        {label}
      </Text>
    </Group>
  );
}
